import React from 'react';

const cities = [
  { name: "Salt Lake City", zips: "84101" },
  { name: "Provo", zips: "84601" },
  { name: "Ogden", zips: "84401" },
  { name: "West Valley City", zips: "84119" },
  { name: "Sandy", zips: "84070" },
  { name: "Orem", zips: "84057" },
  { name: "West Jordan", zips: "84084" },
  { name: "Lehi", zips: "84043" },
];

const benefits = [
  {
    icon: "ri-computer-line",
    title: "Start 100% Online",
    desc: "No office visit required to begin. Complete your order from home or work in minutes.",
  },
  {
    icon: "ri-truck-line",
    title: "Ship Your Documents",
    desc: "Use overnight shipping to send your documents directly to us — we handle the rest.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Expert Document Review",
    desc: "Every application is reviewed by our team before submission to reduce errors and delays.",
  },
  {
    icon: "ri-calendar-check-line",
    title: "Reserved Agency Access",
    desc: "We hold reserved submission slots at the regional passport agency — no public appointment needed.",
  },
];

const landmarks = [
  { name: "SLC International Airport (SLC)", distance: "~8 miles", icon: "ri-plane-line", desc: "Direct flights worldwide — Delta hub" },
  { name: "Utah State Capitol", distance: "~2 miles", icon: "ri-government-line", desc: "Government & state offices" },
  { name: "Temple Square", distance: "Downtown", icon: "ri-building-line", desc: "LDS Church headquarters" },
  { name: "I-15 / I-80", distance: "Adjacent", icon: "ri-road-map-line", desc: "Major interstates through SLC" },
  { name: "University of Utah", distance: "~3 miles", icon: "ri-graduation-cap-line", desc: "Study abroad programs" },
  { name: "LDS Conference Center", distance: "Downtown", icon: "ri-community-line", desc: "Events & gatherings" },
  { name: "Silicon Slopes", distance: "~20 miles", icon: "ri-server-line", desc: "Tech corridor — Lehi to Draper" },
  { name: "SLC Passport Agency", distance: "Downtown", icon: "ri-passport-line", desc: "324 S State St" },
];

export default function SaltLakeCityOfficeInfoSection() {
  return (
    <section id="office-info" className="bg-white pt-6 md:pt-8 pb-20 md:pb-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Serving Salt Lake City &amp; the Wasatch Front
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Whether you are in Salt Lake City, Provo, Ogden, or anywhere along the Wasatch Front, Fast Passport Center makes expedited passport processing simple — as a registered courier, we have guaranteed submission availability at the Salt Lake City Passport Agency.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Left — FPC Info */}
          <div>
            {/* FPC Info Card */}
            <div className="bg-[#1A365D] rounded-lg p-7 text-white">
              <div className="flex flex-col gap-6">
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
                      <i className="ri-passport-line text-[#1A365D] text-xl"></i>
                    </div>
                    <div>
                      <p className="font-bold text-base">Fast Passport Center — Salt Lake City, UT</p>
                      <p className="text-white/60 text-xs mt-0.5">299 S Main St, Suite 200, Salt Lake City, UT 84111</p>
                      <a
                        href="https://maps.google.com/maps?daddr=299+S+Main+St+%23200,+Salt+Lake+City,+UT+84111"
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                        className="inline-flex items-center gap-1 text-[#F6C344] hover:text-white text-xs font-semibold mt-1 transition-colors"
                      >
                        <i className="ri-navigation-line"></i> Get Driving Directions on Google Maps
                      </a>
                    </div>
                  </div>

                  {/* Phone Number */}
                  <div className="flex items-start gap-2.5 mb-3 ml-[52px]">
                    <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0 mt-0.5">
                      <i className="ri-phone-line text-[#F6C344] text-xs"></i>
                    </div>
                    <div>
                      <a href="tel:8772530084" className="text-white/80 text-sm hover:text-[#F6C344] transition-colors">(877) 253-0084</a>
                      <p className="text-white/40 text-xs">Nationwide toll-free — 24/7 voicemail</p>
                    </div>
                  </div>

                  {/* Office Hours */}
                  <div className="flex items-start gap-2.5 mb-4 ml-[52px]">
                    <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0 mt-0.5">
                      <i className="ri-time-line text-[#F6C344] text-xs"></i>
                    </div>
                    <div>
                      <div className="text-white/80 text-sm space-y-0.5">
                        <p className="whitespace-nowrap">Monday – Friday: 9:00 AM – 6:00 PM MST</p>
                        <p className="whitespace-nowrap">Saturday: 10:00 AM – 2:00 PM MST</p>
                        <p className="whitespace-nowrap">Sunday: Closed</p>
                      </div>
                      <p className="text-white/40 text-xs mt-1 italic">After-hours emergency service available by phone</p>
                    </div>
                  </div>

                  {/* Appointment Note */}
                  <div className="flex items-start gap-2.5 mb-4 ml-[52px]">
                    <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0 mt-0.5">
                      <i className="ri-calendar-check-line text-[#F6C344] text-xs"></i>
                    </div>
                    <div>
                      <p className="text-white/80 text-sm font-semibold">Appointment suggested</p>
                      <p className="text-white/50 text-xs mt-0.5 leading-relaxed">Appointment suggested to ensure your documents are reviewed before you arrive.</p>
                    </div>
                  </div>

                  <p className="text-white/70 text-sm mb-1">
                    <i className="ri-map-pin-line text-[#F6C344] mr-1.5"></i>
                    Local office — serving SLC, Provo, Ogden &amp; the Wasatch Front
                  </p>
                  <p className="text-white/50 text-xs mb-4 ml-5">Courier pickup available throughout Salt Lake County</p>
                  <p className="text-white/30 text-[10px] ml-5 mb-4 italic">Last updated: July 18, 2026</p>

                  {/* Office Photo */}
                  <div className="mb-5 rounded-md overflow-hidden border border-white/10">
                    <img
                      src="https://storage.readdy-site.link/project_files/5b15eb5b-af79-4c03-9ad0-73c6095d69a7/2c99de41-5eb8-4e2c-bf68-ea4ec572c393_compressed_Salt-Lake-City-fast-passport-center-office.webp"
                      alt="Fast Passport Center office at 299 S Main St in downtown Salt Lake City — modern glass high-rise tower with plaza and street-level entrance"
                      className="w-full h-auto object-cover object-top"
                    />
                    <div className="px-3 py-2 bg-white/5">
                      <p className="text-white/40 text-xs italic">299 S Main St, Suite 200, Salt Lake City, UT 84111</p>
                    </div>
                  </div>

                  <div className="border-t border-white/10 pt-5">
                    <p className="text-white/80 text-sm leading-relaxed mb-4">
                      After signing up online, choose what works best for you: <strong className="text-white">courier pickup</strong> from your home or office in most cases, <strong className="text-white">ship with our prepaid label</strong> from any UPS/FedEx location, or <strong className="text-white">schedule a drop-off</strong> at our Salt Lake City office. Most clients ship overnight — no visit required.
                    </p>
                    <a
                      href="https://fastpassportcenter.com/checkout/"
                      className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap"
                    >
                      Start My Passport <i className="ri-arrow-right-line"></i>
                    </a>
                  </div>
                </div>

                {/* Map */}
                <div className="w-full">
                  <div className="rounded-lg overflow-hidden border border-white/10" style={{ height: '280px' }}>
                    <iframe
                      src="https://maps.google.com/maps?q=299+S+Main+St+%23200,+Salt+Lake+City,+UT+84111&amp;t=&amp;z=15&amp;ie=UTF8&amp;iwloc=&amp;output=embed"
                      width="100%"
                      height="100%"
                      style={{ border: 0 }}
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title="Fast Passport Center Salt Lake City Office Location"
                      aria-label="Google Map showing Fast Passport Center Salt Lake City office at 299 S Main St Suite 200"
                    />
                  </div>
                  <p className="text-white/40 text-xs mt-2 text-center">
                    299 S Main St, Suite 200, Salt Lake City, UT 84111
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right — Cities + 4 Tiles + Trust */}
          <div>
            <div className="bg-[#F7F8FA] rounded-lg p-7 mb-6 border border-gray-200">
              <h3 className="font-bold text-[#1A365D] text-sm uppercase tracking-wide mb-5">
                <i className="ri-map-pin-2-line text-[#F6C344] mr-2"></i>
                Cities &amp; Communities We Serve
              </h3>
              <div className="space-y-1.5">
                {cities.map((city, i) => (
                  <div
                    key={i}
                    className="flex items-center justify-between py-2.5 px-3 bg-white rounded-md"
                  >
                    <div className="flex items-center gap-2.5">
                      <i className="ri-checkbox-circle-fill text-[#F6C344] text-sm"></i>
                      <span className="text-[#1A365D] font-medium text-sm">{city.name}</span>
                    </div>
                    {city.zips && (
                      <span className="text-gray-400 text-xs font-mono">{city.zips}</span>
                    )}
                  </div>
                ))}
              </div>
              <p className="text-gray-500 text-xs mt-4 leading-relaxed">
                Anywhere in the Wasatch Front — start online, ship overnight, and we handle the rest. As a registered courier, we have guaranteed submission availability at the Salt Lake City Passport Agency.
              </p>
              <div className="mt-4 pt-4 border-t border-gray-100">
                <p className="text-gray-400 text-xs font-semibold uppercase tracking-wider mb-3">Explore Nearby City Pages</p>
                <div className="flex flex-wrap gap-2">
                  {[
                    { name: "Provo", href: "/cities/provo" },
                    { name: "Ogden", href: "/cities/ogden" },
                    { name: "West Valley City", href: "/cities/west-valley-city" },
                    { name: "Sandy", href: "/cities/sandy" },
                    { name: "Lehi", href: "/lehi" },
                    { name: "Draper", href: "/draper" },
                  ].map((link) => (
                    <a
                      key={link.href}
                      href={link.href}
                      className="inline-flex items-center gap-1 text-xs text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors bg-white border border-gray-200 hover:border-[#F6C344] rounded-full px-3 py-1.5 whitespace-nowrap"
                    >
                      {link.name} <i className="ri-arrow-right-line text-[10px]"></i>
                    </a>
                  ))}
                </div>
              </div>
            </div>

            {/* 4 Feature Tiles */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
              {benefits.map((b, i) => (
                <div key={i} className="bg-[#F7F8FA] rounded-lg p-5 border border-gray-200">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#F6C344]/15 mb-3">
                    <i className={`${b.icon} text-[#1A365D] text-base`}></i>
                  </div>
                  <p className="font-bold text-[#1A365D] text-sm mb-1">{b.title}</p>
                  <p className="text-gray-500 text-xs leading-relaxed">{b.desc}</p>
                </div>
              ))}
            </div>

            {/* Trust credentials strip */}
            <div className="bg-[#1A365D] rounded-lg p-5">
              <p className="text-white/50 text-xs uppercase tracking-widest font-semibold mb-4">Why Travelers Choose Fast Passport Center</p>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { icon: "ri-government-line", value: "Registered Courier", label: "U.S. Department of State" },
                  { icon: "ri-award-line", value: "A+ Rating", label: "Better Business Bureau" },
                  { icon: "ri-calendar-check-line", value: "20+ Years", label: "Serving Travelers Nationwide" },
                  { icon: "ri-customer-service-2-line", value: "Real Humans", label: "Live Support — Not a Bot" },
                ].map((item, i) => (
                  <a
                    key={i}
                    href="https://fastpassportcenter.com"
                    className="flex items-center gap-2.5 bg-white/5 hover:bg-white/10 rounded-md px-3 py-2.5 transition-colors cursor-pointer"
                  >
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0">
                      <i className={`${item.icon} text-sm text-[#F6C344]`}></i>
                    </div>
                    <div className="text-left">
                      <span className="text-white text-xs font-bold block leading-tight">{item.value}</span>
                      <span className="text-white/50 text-xs leading-tight block">{item.label}</span>
                    </div>
                  </a>
                ))}
              </div>
            </div>

            {/* Nearby Landmarks */}
            <div className="mt-6">
              <div className="flex items-center gap-2 mb-3">
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#F6C344]/15">
                  <i className="ri-landscape-line text-[#1A365D] text-xs"></i>
                </div>
                <h3 className="font-semibold text-[#1A365D] text-sm uppercase tracking-wide">Nearby Landmarks &amp; Airports</h3>
              </div>
              <div className="flex flex-wrap gap-1.5">
                {landmarks.map((item) => (
                  <span
                    key={item.name}
                    className="inline-flex items-center gap-1.5 bg-[#F7F8FA] border border-gray-200/80 rounded-full px-3 py-1.5 hover:border-[#F6C344] transition-colors cursor-default whitespace-nowrap"
                    title={item.desc}
                  >
                    <i className={`${item.icon} text-[#1A365D] text-[10px]`}></i>
                    <span className="text-[#1A365D] font-medium text-[11px]">{item.name}</span>
                    <span className="text-[#F6C344] font-semibold text-[10px]">{item.distance}</span>
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}